import React, { useEffect, useState } from "react";
import axios, { AxiosError, AxiosResponse } from "axios";
import { Button, Col, Input, Row, Typography } from "antd";
import UserIcon from "@assets/KPMG/User.svg";
import LogoMin from "@assets/KPMG/Logo.svg";
import { Icon } from "@iconify/react";
import { Fade } from "react-awesome-reveal";

export const ChatWindow = () => {
  const [data, setData] = useState<any>([]);
  const [searchText, setSearchText] = useState("");

  const addNew = (question: string) => {
    question = question.trim();
    if (question.length === 0) return;
    let tempData = [...data];
    let obj = {
      question: question,
      answer: "",
      isLoading: true,
    };
    tempData.push(obj);
    setData([...data, obj]);
    setSearchText("");
    axios
      .post(
        "/bot/api/chat",
        { text: question },
        {}
      )
      .then((res: AxiosResponse) => {
        // console.log("res", res);
        if (res) {
          let newData = [...tempData];
          newData[newData.length - 1].answer = res.data;
          newData[newData.length - 1].isLoading = false;
          setData(newData);
        }
      })
      .catch((err: AxiosError) => {
        // console.log("err", err);
        let newData = [...tempData];
        newData[newData.length - 1].answer =
          "Oops, something went wrong. Please try again later.";
        newData[newData.length - 1].isLoading = false;
        setData(newData);
        setSearchText("");
      });
  };

  return (
    <>
      <div
        style={{
          minHeight: "calc(100vh - 110px)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Row>
          <Col span={24}></Col>
        </Row>
        {data.length === 0 && (
          <Row>
            <Col span={24} style={{ marginBottom: 0, textAlign: "center" }}>
              <Typography.Text>Ask AI to find anything</Typography.Text>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={24} style={{ marginBottom: 20 }}>
            <Row>
              {data &&
                data.map((item: any, chatIndex: number) => (
                  <Col span={24} key={`chat${chatIndex}`}>
                    <div>
                      <Row>
                        <Col span={3}></Col>
                        <Col span={21}>
                          {/* <Fade direction="right" triggerOnce> */}
                          <div style={{ display: "flex", marginBottom: 10 }}>
                            <div
                              style={{
                                background: "#003087",
                                padding: "12px 24px",
                                color: "#fff",
                                borderTopLeftRadius: 20,
                                borderTopRightRadius: 20,
                                borderBottomLeftRadius: 20,
                                display: "flex",
                                width: "100%",
                                alignItems: "flex-end",
                              }}
                            >
                              <div className="textSmall">{item.question}</div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-end",
                                marginLeft: 10,
                              }}
                            >
                              <img src={UserIcon} style={{ maxWidth: 20 }} />
                            </div>
                          </div>
                          {/* </Fade> */}
                        </Col>
                      </Row>
                      <Row>
                        <Col span={21}>
                          {/* <Fade direction="left" triggerOnce> */}
                          <div style={{ display: "flex", marginBottom: 20 }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-end",
                                marginRight: 10,
                              }}
                            >
                              <img src={LogoMin} style={{ maxWidth: 48 }} />
                            </div>

                            <div
                              style={{
                                background: "#fff",
                                padding: "12px 24px",
                                boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.16)",
                                borderTopRightRadius: 20,
                                borderBottomRightRadius: 20,
                                borderBottomLeftRadius: 20,
                                display: "flex",
                                width: "100%",
                                alignItems: "flex-end",
                              }}
                            >
                              {item.isLoading && (
                                <Icon
                                  icon="eos-icons:three-dots-loading"
                                  color="#29256e"
                                  fontSize={24}
                                />
                              )}
                              {!item.isLoading && (
                                <div style={{ fontSize: 14, fontWeight: 400 }}>
                                  <Fade cascade damping={0.04} triggerOnce>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item.answer,
                                      }}
                                      className="white-space-pre-line"
                                    ></div>
                                  </Fade>
                                </div>
                              )}
                            </div>
                          </div>
                          {/* </Fade> */}
                        </Col>
                        <Col span={3}></Col>
                      </Row>
                    </div>
                  </Col>
                ))}
              <Col span={24}>
                <div style={{ display: "flex" }}>
                  <div style={{ paddingTop: 0, width: "100%" }}>
                    <div style={{ marginTop: 20 }}>
                      <div style={{ display: "flex" }}>
                        <Input
                          placeholder="Ask AI to find anything"
                          style={{ height: 42 }}
                          value={searchText}
                          onChange={(e) => {
                            setSearchText(e.target.value);
                          }}
                          onPressEnter={(e) => addNew(searchText)}
                        />
                        <Button
                          type="primary"
                          className="btn-primary"
                          style={{
                            height: 42,
                            borderRadius: "24 !important",
                            marginLeft: -50,
                            minWidth: 100,
                          }}
                          onClick={() => addNew(searchText)}
                        >
                          ASK
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col span={4}></Col>
        </Row>
      </div>
    </>
  );
};
